<div class="footer-container">
    @for (item of menu; track item) {
    <div class="icon-container">
        <button mat-icon-button  class="footer-icon" (click)="navigate(item.url)">
            <mat-icon fontSet="material-symbols-outlined">{{item.icon}}</mat-icon>
        </button>
        <mat-label class="icon-lbl">{{item.label}}</mat-label>
    </div>
    }
    
</div>
